import React from 'react';
import './Menu.css';
import IconBrokers from './imagenes/Brokers.png';
import IconFinanciero from './imagenes/AisistenteFinanciero.png';
import IconNormas from './imagenes/NormasAdministrativas.png';
import IconInvestigaciones from './imagenes/UIF.png';
import IconIRGRD from './imagenes/IR_GRD.png';
import { useNavigate } from 'react-router-dom';

const handleIconClick = (nro) => {
    console.log(nro);
};

function Menu() {
   const navigate = useNavigate(); 
    const handleIconClick = (nro) => {
        console.log(nro);
        if(nro===1) {
          navigate('/Chatsiniestro');
        } else if(nro===2) {
          navigate('/Chatventa');
        }else if(nro===3) {
          navigate('/Chatbox');
        } else if(nro===4) {
          navigate('/Chatnorma');
        } else if(nro===5) {
          navigate('/ChatGRD');
        } else if(nro===6) {
          navigate('/Chatfaq');
        }
    };
    return (
      <div className="menu-container">
        <div className="menu-item" onClick={() => handleIconClick(1)}>
          <img src={IconNormas} alt="Asistente de Siniestros" />
          <p>Siniestros automotriz</p>
        </div>
        <div className="menu-item" onClick={() => handleIconClick(2)}>
          <img src={IconBrokers} alt="Asistente de Ventas" />
          <p>Asistente de Ventas</p>
        </div>
        <div className="menu-item" onClick={() => handleIconClick(3)}>
          <img src={IconInvestigaciones} alt="Asistente de Suscripción" />
          <p>Asistente de Suscripción</p>
        </div>
        <div className="menu-item" onClick={() => handleIconClick(4)}>
          <img src={IconFinanciero} alt="Asistente de Brokers" />
          <p>Asistente de normas (Brokers)</p>
        </div>
        <div className="menu-item" onClick={() => handleIconClick(5)}>
          <img src={IconIRGRD} alt="Asistente para IR-GRD" />
          <p>Asistente para IR-GRD</p>
        </div>
        <div className="menu-item" onClick={() => handleIconClick(6)}>
          <img src={IconNormas} alt="Frequently Ask question" />
          <p>FAQ</p>
        </div>
      </div>
    );
  }
  
  export default Menu;